<template>
<div class="sidebar">
    <el-menu class="sidebar-el-menu" :default-active="onRoutes" :collapse="collapse" :background-color="menuBarBackgroundColor" text-color="#bfcbd9" active-text-color="#20a0ff" unique-opened router>
        <template v-for="item in items">
            <template v-if="item.subs">
                <el-submenu :index="item.code" :key="item.code">
                    <template slot="title">
                        <i :class="item.icon"></i>
                        <span slot="title">{{ item.title }}</span>
                    </template>
                    <template v-for="subItem in item.subs">
                        <el-submenu v-if="subItem.subs" :index="subItem.code" :key="subItem.code">
                            <template slot="title">{{ subItem.title }}</template>
                            <el-menu-item v-for="(threeItem, i) in subItem.subs" :key="i" :index="threeItem.code">
                                {{ threeItem.title }}</el-menu-item>
                        </el-submenu>
                        <el-menu-item v-else :index="subItem.code" :key="subItem.code + 1">{{ subItem.title }} </el-menu-item>
                    </template>
                </el-submenu>
            </template>
            <template v-else>
                <el-menu-item :index="item.code" :key="item.code">
                    <i :class="item.icon"></i>
                    <span slot="title">{{ item.title }}</span>
                </el-menu-item>
            </template>
        </template>
    </el-menu>
</div>
</template>

<script>
import bus from '../common/bus';
import {
    SortField
} from '../../utils/helper';
export default {
    data() {
        return {
            collapse: false,
            items: [],
            menuBarBackgroundColor: '#324157',
            menuTextColor: '#bfcbd9'
        };
    },
    computed: {
        onRoutes() {
            return this.$route.path.replace('/', '');
        }
    },
    created() {
        this.getSystemInfo();
        this.getData();
        // 通过 Event Bus 进行组件间通信，来折叠侧边栏
        bus.$on('collapse', (msg) => {
            this.collapse = msg;
            bus.$emit('collapse-content', msg);
        });
    },
    mounted() {},
    methods: {
        getData() {
            let username = localStorage.getItem('ms_username');
            let userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));
            if (username != undefined && username != null) {
                this.$zybhttp
                    .post('Menu/GetMenuLeft', {
                        Field1: userInfo.userType
                    })
                    .then((res) => {
                        if (res.data.status == 0) {
                            res = res.data;
                            var d = res.data.list;
                            var list = this.MenuCarding(d);
                            this.items = list;
                        } else {
                            this.$notify.error(res.message);
                        }
                    })
                    .catch((err) => this.$notify.error('网络异常！获取菜单失败！'));
            }
        },
        MenuCarding(data) {
            var menus = [];
            var d = JSON.parse(JSON.stringify(data));
            var dOne = d.filter((x) => x.parentId == 0);
            // var dOne = d.filter(function (e) {
            //     return e.parentId == 9999;
            // });
            var dOneSort = dOne.sort(SortField('sort', 'asc')).map((x) => {
                return {
                    id: x.id,
                    code: x.code,
                    icon: x.icon,
                    title: x.title
                };
            });
            menus = menus.concat(dOneSort);
            menus.forEach((x) => {
                var pid = x.id;
                var dtwo = d.filter((x) => x.parentId == pid);
                if (dtwo.length > 0) {
                    var dtwoSort = dtwo.sort(SortField('sort', 'asc')).map((x) => {
                        return {
                            id: x.id,
                            code: x.code,
                            icon: x.icon,
                            title: x.title
                        };
                    });
                    x.subs = dtwoSort;
                }
            });
            return menus;
        },
        getSystemInfo() {
            this.$zybhttp
                .get('Business/GetSystemInfo', {})
                .then((res) => {
                    if (res.data.status == 0) {
                        var d = res.data;
                        this.version = d.msg;
                        this.menuBarBackgroundColor = d.data.list[0].menuBarBackgroundColor;
                        this.menuTextColor = d.data.list[0].textColor;
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error('网络异常！获取列表失败！'));
        },
    }
};
</script>

<style scoped>
.sidebar {
    display: block;
    position: absolute;
    left: 0;
    top: 50px;
    bottom: 0;
    overflow-y: scroll;
}

.sidebar::-webkit-scrollbar {
    width: 0;
}

.sidebar-el-menu:not(.el-menu--collapse) {
    width: 250px;
}

.sidebar>ul {
    height: 100%;
}
</style>
